module.exports = __webpack_public_path__ + "img/health-bg 1 (1).e332288d.png";